import axios from "axios";
import * as xml2jsfrom from "xml2js";
import { ResponseModel } from "@/models";

const __API__ = process.env.VUE_APP_UPLOAD_API;

export abstract class UploadService {
  static BASE: string = "state";
  static async Upload(
    formData: FormData,
    filename: string
  ): Promise<ResponseModel<number>> {
    let response = new ResponseModel<number>(0, 0);
    let uploader = `${__API__}&fileName=${filename}`;
    try {
      const res = await axios.post(uploader, formData);
      if (res.status === 200) {
        console.log("success fetch");
        let pictureId = 0;
        // the result return xml, convert it to object
        xml2jsfrom.parseString(res.data, function(err: any, result: any) {
          pictureId = result.multipowupload.response[0] as number;
        });
        response.status = 200;
        response.data = pictureId;
      }
    } catch (err) {
      console.log(err);
      response.status = 403;
      response.error = err;
    }
    return response;
  }
}
